export default "__VITE_ASSET__ChfgN3g8__"